import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { Store } from '@ngrx/store'
import { BsModalService } from 'ngx-bootstrap/modal'
import { combineLatest, Observable } from 'rxjs'
import { map, startWith } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { BulkActionEvent, BulkAction } from 'src/app/shared/interfaces'
import { getEnumAsArray } from 'src/app/shared/until'
import { internalEventActions } from '../../internal-event/internal-event.actions'
import { internalEventSelectors } from '../../internal-event/internal-event.selectors'
import { InternalEventTypes } from '../../operation/operation-internal-event/internal-event-types'
import { OperationInternalEvent } from '../../operation/operation-internal-event/operation-internal-event'
import { operationInternalEventActions } from '../../operation/operation-internal-event/operation-internal-event.actions'
import { operationInternalEventSelectors } from '../../operation/operation-internal-event/operation-internal-event.selectors'
import { productActions } from '../../product/product.actions'
import { productSelectors } from '../../product/product.selectors'
import { subscriptionActions } from '../../subscription/subscription.actions'
import { subscriptionSelectors } from '../../subscription/subscription.selectors'
import { surveyActions } from '../../survey/survey.actions'
import { surveySelectors } from '../../survey/survey.selectors'

@Component({
  selector: 'configuration-option-internal-operation-events',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionInternalOperationEventsComponent
  implements OnInit
{
  public isLoading$: Observable<boolean>
  public operationInternalEvents$: Observable<OperationInternalEvent[]>
  public internalEventTypes = getEnumAsArray(InternalEventTypes)
  public accessRights = AccessRights

  constructor(private store: Store<AppState>, private router: Router) {}

  ngOnInit() {
    this.isLoading$ = this.store
      .select(operationInternalEventSelectors.selectIsLoading)
      .pipe(startWith(false))

    this.store.dispatch(
      operationInternalEventActions.fetchMany({
        params: RequestQueryBuilder.create({
          join: [{ field: 'course' }, { field: 'survey' }, { field: 'product' }]
        })
      })
    )

    //  this.store.dispatch(productActions.fetchMany({}))
    this.store.dispatch(subscriptionActions.fetchMany({}))
    this.store.dispatch(surveyActions.fetchMany({}))
    this.store.dispatch(internalEventActions.fetchMany({}))

    this.operationInternalEvents$ = combineLatest([
      this.store.select(operationInternalEventSelectors.selectAll),
      this.store.select(productSelectors.selectEntities),
      this.store.select(subscriptionSelectors.selectEntities),
      this.store.select(surveySelectors.selectEntities),
      this.store.select(internalEventSelectors.selectEntities)
    ]).pipe(
      map(
        ([
          events,
          productEntities,
          subscriptionEntities,
          surveyEntities,
          internalEventEntities
        ]) => {
          if (!internalEventEntities) {
            return []
          }

          let eventsArray = []

          events.map((event) => {
            let eventObj = {
              ...event,
              product: productEntities[event.productId] ?? null,
              subscription: subscriptionEntities[event.subscriptionId] ?? null,
              survey: surveyEntities[event.surveyId] ?? null,
              internalEventType: this.internalEventTypes.filter(
                (type) =>
                  internalEventEntities[event.internalEventId]?.type ==
                  type.value
              )
            }
            eventsArray.push(eventObj)
          })

          return eventsArray
        }
      )
    )
  }

  public onClickRow(operationInternalEvent: OperationInternalEvent) {
    this.router.navigate([
      '/operation-internal-events',
      operationInternalEvent.id
    ])
  }

  public onClickCreate() {
    this.router.navigate(['/operation-internal-events/create'])
  }

  public onBulkAction(bulkActionEvent: BulkActionEvent) {
    if (bulkActionEvent.action == BulkAction.DELETE) {
      bulkActionEvent.items.forEach((i) =>
        this.store.dispatch(
          operationInternalEventActions.deleteOne({ id: i.id })
        )
      )
    }
  }
}
